module.exports = __webpack_public_path__ + "media/src/images/testimonials/04-4c567f68f3c40528e9235d38e47f440b.jpg";